import type { Locale } from "@taunggyi-plus/domain";
import { EventsWorkspace } from "@taunggyi-plus/finance-feature";
export function CustomerEvents({ locale }: { readonly locale: Locale }) {
  return (
    <div lang={locale}>
      <EventsWorkspace />
    </div>
  );
}
